import { useMatchesViewport } from 'common/hooks/media';

const enum FrameOverflow {
  Visible = 'visible',
  Hidden = 'hidden',
}

const SLIDES_TO_SHOW_S_M = 1;
const SLIDES_TO_SHOW_L_XL = 2;

const getFrameOverflow = (matchesLargeDesktop: boolean) =>
  matchesLargeDesktop ? FrameOverflow.Hidden : FrameOverflow.Visible;

const getSlidesToShow = (matchesDesktop: boolean) =>
  matchesDesktop ? SLIDES_TO_SHOW_L_XL : SLIDES_TO_SHOW_S_M;

export const useSlideSize = () => {
  const { matches } = useMatchesViewport();
  const { matchesDesktop, matchesLargeDesktop } = matches;

  return {
    frameOverflow: getFrameOverflow(matchesLargeDesktop),
    slidesToShow: getSlidesToShow(matchesDesktop),
  };
};
